<template>
  <div id="Hotspot">

    <Head v-if="isAdmin" />
    <div class="hotspot clear">
      <Nav ms="/Bgjurisdiction" v-if="isAdmin" />
      <div class="H-right">
        <div class="title">{{ isAdmin ? '申报权限管理' : '员工列表' }}</div>
        <div class="H-header">
          <input v-if="type == 2 && isAdmin" type="text" v-model="selName" placeholder="请输入公司名称查询" />
          <input type="text" v-model="phone" placeholder="请输入手机号查询" />
          <select v-model="selStatus" @change="getGl">
            <option value>全部</option>
            <option value="0">未审核</option>
            <option value="1">已通过</option>
            <option value="2">已停用</option>
          </select>
          <div v-if="tableData1.length > 0" class="btn1" @click="excel()">
            <i></i>
            导出数据
          </div>
          <!-- <div class="btn" @click="getinfo(1)">查询</div> -->
        </div>
        <div class="t_main">
          <el-table border :header-cell-style="{ 'background-color': '#001743', 'color': '#fff', 'height': '0.5rem' }"
            :stripe="true" :data="tableData1" :style="{ 'width': width }" :row-style="{ 'height': '0.4rem' }">
            <el-table-column type="index" width="60" label="序号" header-align="center" align="center"></el-table-column>
            <el-table-column prop="Realname" label="姓名" header-align="center" align="center"></el-table-column>
            <el-table-column prop="Phone" label="手机号" header-align="center" align="center"></el-table-column>
            <el-table-column prop="Department" label="所在部门" header-align="center" align="center"></el-table-column>
            <el-table-column prop="Position" label="职称" header-align="center" align="center"></el-table-column>
            <el-table-column label="注册详情" header-align="center" align="center">
              <template slot-scope="scope">
                <el-button size="mini" @click="Popups(1, scope.row)">查看</el-button>
              </template>
            </el-table-column>
            <el-table-column prop="watchnums" label="状态" header-align="center" align="center">
              <template slot-scope="scope">
                <span>{{ scope.row.Status == 0 ? '待审核' : scope.row.Status == 1 ? '正常' : '禁用' }}</span>
              </template>
            </el-table-column>
            <el-table-column label="操作" header-align="center" align="center">
              <template slot-scope="scope">
                <el-button size="mini" v-if="scope.row.Status == 0" @click="Popups(1, scope.row)"
                  type="primary">审核</el-button>
                <el-button size="mini" v-if="scope.row.Status == 1" @click="setInfo(2, scope.row)"
                  type="danger">禁用</el-button>
                <el-button size="mini" v-if="scope.row.Status == 2" @click="setInfo(1, scope.row)"
                  type="primary">启用</el-button>
                <el-button @click="delInfo(scope.row)" size="mini" type="danger"
                  style="margin:.1rem 0 0 .01rem ">删除</el-button>
              </template>
            </el-table-column>
          </el-table>
          <el-pagination style="text-align: right;height: 0.45rem;" v-if="tableData1.length > 0"
            @current-change="CurrentChange1" @size-change="handleSizeChange1" :current-page="Page1" :page-size="PageSize1"
            :page-sizes="[10, 20, 30]" layout="total,sizes, prev, pager, next, jumper" :total="total1"></el-pagination>
        </div>
        <div class="Popup" v-show="isPopup">
          <div class="none" @click="Popups"></div>
          <div v-if="isPopup" class="a_forms">
            <div class="f-top">
              <img src="../../assets/back/x.png" @click="Popups" alt />
              用户审核
            </div>
            <div class="f-info">
              <div class="f-title">
                <div class="f-left">
                  <div>
                    <span>用户名</span>
                    <a>:</a>
                    <em>{{ user.Realname }}</em>
                  </div>
                  <div>
                    <span>手机号</span>
                    <a>:</a>
                    <em>{{ user.Phone }}</em>
                  </div>
                  <div>
                    <span>电子邮箱</span>
                    <a>:</a>
                    <em>{{ user.Email }}</em>
                  </div>
                  <!-- <div>
                    <span>省份</span>
                    <a>:</a>
                    <em>{{user.Province}}</em>
                  </div>-->
                  <!-- <div>
                    <span>所在企业</span>
                    <a>:</a>
                    <em>{{user.Name}}</em>
                  </div>-->
                </div>
                <div class="f-left f-right">
                  <div>
                    <span>所在部门</span>
                    <a>:</a>
                    <em>{{ user.Department }}</em>
                  </div>
                  <div>
                    <span>职务</span>
                    <a>:</a>
                    <em>{{ user.Position }}</em>
                  </div>
                  <div>
                    <span>地址</span>
                    <a>:</a>
                    <em>{{ user.City }}</em>
                  </div>
                  <!-- <div>
                    <span>电子邮箱</span>
                    <a>:</a>
                    <em>{{user.Email}}</em>
                  </div>-->
                </div>
              </div>
              <div class="f-bottom" v-if="user.Status == 0">
                <div style="margin-right:0.2rem;">审核结果</div>
                <div class="btn" @click="setInfo(1)" style="margin-right:0.2rem;">审核通过</div>
                <div @click="setInfo(2)" class="btn">禁用</div>
                <div class="btn" @click="delInfo()" style="background:#F56C6C;margin-left:0.2rem;">删除</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <Foot v-if="isAdmin" />
  </div>
</template>
<script>
import Head from "../../components/BackHead";
import Foot from "../../components/Foot";
import Nav from "../../components/BackNav";
export default {
  name: "Jurisdiction",
  data() {
    return {
      total1: 1,
      tableData1: [],
      type: "",
      Page1: 1,
      value: "1",
      PageSize1: 10,
      user: "",
      isPopup: false,
      selName: "",
      selStatus: "",
      phone: ""
    };
  },
  props: {
    isAdmin: {
      type: Boolean,
      default: true
    },
    CompanyID: {
      type: Number,
      default: 0
    },
    width: {
      type: String,
      default: "100%"
    }
  },
  created() {
    this.getinfo();
    this.type = sessionStorage.getItem("type");
  },
  watch: {
    phone: function () {
      clearTimeout(this.time);
      this.Page1 = 1
      this.time = setTimeout(() => {
        this.getinfo();
      }, 1000);
    }
  },
  methods: {
    excel() {
      window.location.href =
        this.$URL +
        "/excel/ownusers?token=" +
        sessionStorage.getItem("token") +
        "&Company=" +
        (this.CompanyID == 0 ? "" : this.CompanyID);
    },
    delInfo(a) {
      //
      if (a) {
        this.user = a;
      }
      this.$confirm("删除此用户, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          let that = this;
          console.log(that.user);
          that.$axios
            .post(
              "user/del",
              that.$qs.stringify({
                token: sessionStorage.getItem("token"),
                ID: that.user.ID
              })
            )
            .then(res => {
              if (res.data.code == 10000) {
                that.$message({
                  message: res.data.msg,
                  type: "success"
                });
                that.$axios.post(
                  "message/updatestatus",
                  that.$qs.stringify({
                    token: sessionStorage.getItem("token"),
                    type: 0
                    // operator: this.user.ID
                  })
                );
                that.isPopup = false;
                that.getinfo();
              } else {
                that.$message.error(res.data.msg);
              }
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除"
          });
        });
    },
    getGl() {
      this.getinfo(1);
    },
    Popups(a, b) {
      if (a == 1) {
        this.user = Object.assign({}, b);
        console.log(this.user, 666);
      }
      this.isPopup = !this.isPopup;
    },
    CurrentChange1(val) {
      //console.log(val)
      this.Page1 = val;
      //this.GetClass()
      this.getinfo();
    },
    handleSizeChange1(val) {
      //console.log(val)
      this.PageSize1 = val;
      //this.GetClass()
      this.getinfo();
    },
    getinfo(a) {
      if (a == 1) {
        this.Page1 = 1;
      }
      var that = this;
      that.$axios
        .post(
          "user/index?token=" + sessionStorage.getItem("token"),
          that.$qs.stringify({
            Company: this.CompanyID != 0 ? this.CompanyID : "",
            realname: this.selName,
            phone: this.phone,
            status: this.selStatus,
            Type: 1,
            page: this.Page1,
            num: this.PageSize1
          })
        )
        .then(res => {
          if (res.data.code == 10000) {
            console.log(res.data);
            this.tableData1 = res.data.data.list;
            this.total1 = res.data.data.total_num;
          } else {
            this.$message({
              message: res.data.msg,
              type: "warning"
            });
          }
        });
    },
    setInfo(a, b) {
      if (b) {
        this.user = Object.assign({}, b);
      }
      var that = this;

      this.$confirm("确认提交吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          this.user.Status = a;
          that.$axios
            .post(
              "user/update?token=" + sessionStorage.getItem("token"),
              that.$qs.stringify(this.user)
            )
            .then(res => {
              console.log(res);
              if (res.data.code == 10000) {
                that.$message({
                  message: res.data.msg,
                  type: "success"
                });
                that.isPopup = false;
                that.getinfo();
              } else {
                that.$message.error(res.data.msg);
              }
            });
          that.$axios.post(
            "message/updatestatus",
            that.$qs.stringify({
              token: sessionStorage.getItem("token"),
              type: 0
            })
          );
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消"
          });
        });
    }
  },
  components: {
    Head,
    Foot,
    Nav
  }
};
</script>
<style scoped lang="less">
.clear:after {
  /*伪元素是行内元素 正常浏览器清除浮动方法*/
  content: "";
  display: block;
  height: 0;
  clear: both;
  visibility: hidden;
}

.btn {
  width: 1rem;
  cursor: pointer;
  height: 0.4rem;
  line-height: 0.4rem;
  font-size: 0.17rem;
  text-align: center;
  background: #409eff;
  border-radius: 0.04rem;
  color: #fff;
}

.hotspot {
  width: 100%;
  min-width: 1000px;
  font-size: 0.16rem;
  padding: 0.28rem 2.54rem;
  box-sizing: border-box;

  .H-right {
    position: relative;
    width: 11.5rem;
    min-width: 750px;
    padding-left: 0.2rem;
    height: 100%;
    float: right;
    min-height: 7.4rem;
    border-left: 1px #eeeeee solid;

    .title {
      font-size: 0.4rem;
      margin: 0.2rem 0 0.5rem;
      text-align: center;
    }

    .H-header {
      display: flex;
      justify-content: flex-start;
      align-items: center;
      height: 0.5rem;
      position: relative;

      .btn1 {
        background: #2d65d2;
        width: 1.3rem;
        height: 0.4rem;
        color: #fff;
        border-radius: 0.05rem;
        text-align: center;
        line-height: 0.5rem;
        line-height: 0.4rem;
        display: flex;
        position: absolute;
        right: -0.12rem;
        cursor: pointer;
        top: 0.05rem;
        z-index: 10;

        // justify-content: center;
        // align-items: center;
        i {
          margin: 0.07rem 0 0 0.07rem;
          width: 0.4rem;
          height: 0.4rem;
          background-image: url("../../assets/back/Excel.png");
          background-repeat: no-repeat;

          // background-size: 50%  100%;
        }
      }

      span,
      select,
      div,
      input {
        margin-right: 0.2rem;
      }

      input,
      select {
        height: 0.4rem;
        width: 2rem;
        padding: 0.05rem;
      }
    }
  }
}

.Popup {
  width: 100%;
  position: absolute;
  top: 0;
  height: 100%;
  background: rgba(0, 0, 0, 0.6);
  z-index: 1000;

  .none {
    width: 100%;
    height: 100%;
    position: relative;
  }

  .a_forms {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    width: 10.11rem;

    background: white;
    font-size: 0.16rem;

    .f-top {
      height: 0.5rem;
      width: 100%;
      text-align: center;
      line-height: 0.5rem;
      position: relative;
      border-bottom: 1px #cfcfcf solid;

      img {
        position: absolute;
        right: 0.1rem;
        top: 50%;
        transform: translate(0, -50%);
      }
    }

    .f-info {
      padding: 0 0.54rem;

      .f-title {
        position: relative;
        overflow: hidden;
        padding-bottom: 0.5rem;
        border-bottom: 1px #cfcfcf solid;

        .f-left {
          overflow: hidden;
          position: relative;

          >img {
            margin-left: 1.2rem;
          }

          >div {
            margin: 0.3rem 0.18rem;
            vertical-align: top;

            >span {
              width: 0.8rem;
              text-align: justify;
              text-align-last: justify;
              color: #505050;
              display: inline-block;
            }

            >a {
              color: #505050;
              font-style: normal;
            }

            >em {
              margin-left: 0.3rem;
              color: #272727;
              font-style: normal;
            }
          }
        }

        .f-right {
          position: absolute;
          top: 0;
          right: 0;
          width: 50%;
        }
      }

      .f-bottom {
        margin: 0.2rem 0.2rem;
        display: flex;
        align-items: center;
      }
    }
  }
}
</style>